import { cn } from '~/shadcn/lib/utils'

type Props = React.HTMLAttributes<HTMLHeadingElement>

function HeadingThree({ className, ...props }: Props) {
  return (
    <h3
      className={cn(
        'text-[1.25rem] leading-[1.1] font-semibold tracking-[0.01rem]',
        'md:text-[1.5rem]',
        className
      )}
      {...props}
    />
  )
}

export { HeadingThree }
